export default __webpack_public_path__ + "static/media/email.ffaa297e.svg";